import { render } from "./PageCreateComponent.vue?vue&type=template&id=55ff44fa"
import script from "./PageCreateComponent.vue?vue&type=script&lang=js"
export * from "./PageCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Page/PageCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55ff44fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55ff44fa', __exports__)) {
    api.reload('55ff44fa', __exports__)
  }
  
  module.hot.accept("./PageCreateComponent.vue?vue&type=template&id=55ff44fa", () => {
    api.rerender('55ff44fa', render)
  })

}


export default __exports__